import React, { useMemo } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import moment from 'moment';

const ViewMillReceivePoDataModal = ({ modalOpen, setModalOpen, data }) => {
    console.log(data, 'data');
    const poColumns = [
        {
            Header: 'challan No.',
            accessor: 'challanNo',
        },
        {
            Header: 'lotNo',
            accessor: 'lotNo',
        },
        {
            Header: 'hsnCode',
            accessor: 'hsnCode',
        },
        {
            Header: 'amount',
            accessor: 'amount',
        },
        {
            Header: 'rate',
            accessor: 'rate',
        },
        {
            Header: 'PCS',
            accessor: 'PCS',
        },
        {
            Header: 'greyMt',
            accessor: 'greyMt',
        },
        {
            Header: 'finalMt',
            accessor: 'finalMt',
        },
        {
            Header: 'Date',
            Cell: ({ row }) => {
                return moment(row?.original?.date).format('DD/MM/YYYY');
            },
        },
    ];
    const colsMemo = useMemo(() => poColumns ?? [], [poColumns]);
    const poDataMemo = useMemo(
        () => (data && data?.length > 0 ? data : []),
        [data]
    );

    const cuttingCardData = data?.cuttingCard.reduce((acc, d) => {
        if (!acc[d.cuttingCardNumber]) {
            acc[d.cuttingCardNumber] = [];
        }
        acc[d.cuttingCardNumber].push(d.millChallanNo);
        return acc;
    }, {});

    const jobWorkData = data?.jobWork.reduce((acc, d) => {
        if (!acc[d.jobWorkNumber]) {
            acc[d.jobWorkNumber] = [];
        }
        acc[d.jobWorkNumber].push(d.cuttingCard?.cuttingCardNumber);
        return acc;
    }, {});

    return (
        <ModalBasic modalOpen={modalOpen} setModalOpen={setModalOpen}>
            <div className="p-4">
                <TableWithHeadingAndSearch
                    columns={colsMemo}
                    data={poDataMemo}
                    heading={'Purchase Order Details'}
                />
                <div className="p-2">
                    <h2 className="mt-2 font-semibold">Mill Dispatch</h2>
                    <div>{data?.poData.map((d) => d.challanNo).join(', ')}</div>
                    <div className="mt-2">
                        <h2 className="font-semibold">Mill Receive</h2>
                        <div>
                            <div>
                                <span>
                                    Invoice No. {data?.invoiceNo} -{' '}
                                    {data?.poData
                                        .map((d) => d.challanNo)
                                        .join(', ')}
                                </span>
                            </div>
                        </div>
                    </div>
                    {data?.cuttingCard?.length > 0 && (
                        <div className="mt-2">
                            <h2 className="font-semibold">Cutting Card</h2>
                            {cuttingCardData &&
                                Object.entries(cuttingCardData).map(
                                    ([invoiceNumber, challans]) => (
                                        <div key={invoiceNumber}>
                                            <span>
                                                CC No. {invoiceNumber} -{' '}
                                                {challans
                                                    .map((d) => d)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                    )
                                )}
                        </div>
                    )}
                    {data?.jobWork?.length > 0 && (
                        <div className="mt-2">
                            <h2 className="font-semibold">Job Work</h2>
                            {jobWorkData &&
                                Object.entries(jobWorkData).map(
                                    ([invoiceNumber, challans]) => (
                                        <div key={invoiceNumber}>
                                            <span>
                                                Invoice No. {invoiceNumber} -{' '}
                                                {challans
                                                    .map((d) => d)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                    )
                                )}
                        </div>
                    )}
                </div>
            </div>
        </ModalBasic>
    );
};

export default ViewMillReceivePoDataModal;
